const tarotDetail = {
  'header.title': '塔羅牌盤',
  'header.tag': '塔羅牌盤',
  'header.manage': '檔案管理',
  'header.solarLabel': '公曆',
  'header.lifeNumber': '靈數: {{n}}',
  'tabs.portrait': '塔羅探索',
  'tabs.daily': '默念一抽',
  'tabs.spread': '塔羅牌陣',
  'tabs.classic_spread': '經典牌陣',
  'tabs.meaning': '塔羅牌義',
  'tabs.trainer': '識牌訓練器',

  common: {
    upright: '正位',
    reversed: '逆位',
    current: '當前',
    clickExpand: '點擊展開',
    clickExpandDetail: '點擊展開詳析',
    beginnerRead: '小白必讀',
    flourishing: '旺盛',
    stable: '平穩',
    brewing: '蓄力中',
    good: '良好',
    average: '一般',
    needAttention: '需關注',
    uprightEnergy: '正位能量',
    reversedTip: '逆位提示',
    resolutionTitle: '行動建議',
    beginnerGuide: '小白解讀指南',
    pts: '分',
  },

  daily: {
    badge: '本次抽牌',
    majorArcana: '大阿爾卡納',
    cardReading: '牌面解讀',
    keywords: '關鍵詞',
    todaySuggestion: '今日建議',
    overallFortune: '整體運勢',
    love: '愛情',
    career: '事業',
    cardIntroTitle: '關於「{{name}}」',
    beginnerTag: '小白入門',
    numberSymbol: '牌面編號與象徵',
    majorArcanaIntro: '{{name}}（{{en}}）是大阿爾卡納第{{num}}號牌，屬於22張主牌之一，代表塔羅體系中最核心的原型能量。大阿爾卡納每一張都對應一個世界性的原型與人生課題，象徵了人類普遡經歷的生命履程。',
    uprightCore: '正位核心',
    reversedTip: '逆位提示',
    todayAction: '今日行動建議',
    redraw: '重新抽取',
    personalCard: '{{name}} 於 {{date}} 的隨機占問結果（重新抽取將獲得新牌）',
    energyReading: '塔羅能量解讀',
    multiDimTitle: '多維度展開解讀',
    loveDeepLabel: '感情',
    careerDeepLabel: '事業',
    wealthDeepLabel: '財富',
    socialDeepLabel: '人際',
    bodyDeepLabel: '身心',
    mindDeepLabel: '情緒心態',
    timeGuideTitle: '時空指引',
    luckyHour: '吉時',
    luckyColor: '幸運色',
    luckyNumber: '幸運數',
    luckyDirection: '吉方',
    actionGuideTitle: '今日行動指南',
    philosophyTitle: '塔羅智慧啟示',
    cardThemeTitle: '本次牌面主題',
    uprightTheme: '正位能量',
    reversedWatch: '逆位提醒',
    coreReminderTitle: '核心提醒',
    actionCaution: '需要注意',
    reflectionTitle: '反思問題',
    reflectQ1Upright: '在今天正位能量中，我最想發揮的是哪一面、最被抹殺的是哪一面？',
    reflectQ1Reversed: '逆位帶來的阻礙，目前對我影響最大的具體是什麼場景或情緒？',
    reflectQ2: '如果讓今天的牌面給我一句話，最想對我說什麼？',
    readingRef: '閱讀參考',
    todayActionLabel: '行動建議',
  },

  spread: {
    selectTitle: '選擇牌陣',
    cardCount: '{{n}}張牌',
    reselect: '重新選擇',
    overallReading: '綜合解讀',
    resolution: '行動建議',
    positionAnalysis: '逐位解析',
    clickExpand: '點擊展開',
    upright: '正位',
    reversed: '逆位',
    personalNote: '此牌陣為 {{name}} 專屬推算',
    resolutionTitle: '行動建議',
    beginnerGuide: '小白解讀指南',
    beginnerText: '本週主牌根據你的出生資訊與本週能量共同推算而來。塔羅事業解讀不是預言你會升職或失業，而是揭示本週最適合你的行動策略。',
    drawingTitle: '抽取牌陣',
    drawingDesc: '點擊下方牌背，逐張揭示你的牌陣',
    revealCard: '揭示',
    viewResult: '查看完整解讀',
    cardBackHint: '點擊翻開',
    remainingCards: '還需翻開 {{n}} 張牌',
    keyTheme: '核心主題',
    energyFlow: '能量流動',
    dailyInsight: '當日啟示',
    combinationAnalysis: '牌組綳合分析',
    interpretChain: '解讀鏈',
    comprehensiveAdvice: '綜合行動建議',
    timeNodes: '時間能量節點',
    philosophyNote: '塔羅哲學寄語',
    positionInsight: '位置洞察',
    loveHint: '感情維度',
    careerHint: '事業維度',
    actionAdvice: '行動建議',
    cautionNote: '溫馨提示',
    energyDirection: '能量走向',
    cardJiehua: '行動建議',
    drawStep: '第 {{n}} 張',
    drawProgress: '已翻開 {{revealed}}/{{total}} 張',
    nextCardHint: '點擊翻開下一張',
    drawOrderTitle: '抽牌順序',
  },

  meaning: {
    intro: '塔羅牌共78張，分為22張大阿爾卡納（重大原型）和56張小阿爾卡納（4組×14張，代表日常生活中的各種情境）。點擊下方花色了解各組含義，點擊牌面進入詳細解讀。',
    suits: ['大阿爾卡納', '權杖組', '聖杯組', '寶劍組', '星幣組'],
    majorTitle: '關於大阿爾卡納',
    majorDesc: '22張大阿爾卡納是塔羅的核心，從「愚者」（0）到「世界」（21），代表一個生命歷程的完整旅途——從天真無畏的出發，到圓滿整合的歸宿。每張牌都是一個宇宙原型，象徵人類普遍的生命課題。點擊牌面查看詳細牌義。',
    cardNumberUnit: '張',
    elementLabel: '元素',
    themeLabel: '主題',
    expandHint: '牌號含義速查',
    expandHintTag: '點擊展開',
    inSuitAce: '{{suit}}王牌代表{{element}}元素最純粹的能量啟動，是{{theme}}領域新征程的信號。',
    inSuitOther: '{{suit}}{{label}}把通用含義與「{{theme}}」的領域相結合，解讀時需考慮問題的情境。',
    minorInfo: [
      { suit: '權杖組', element: '火', theme: '行動·創意·激情', desc: '權杖對應火元素，代表生命力、創造力與行動驅動。在解讀中出現權杖，通常意味著需要主動出擊，勇敢嘗試，或正處於充滿熱情的階段。', icon: 'ri-fire-line', color: '#E8A020' },
      { suit: '聖杯組', element: '水', theme: '情感·直覺·關係', desc: '聖杯對應水元素，代表情感世界、直覺感知與人際連結。聖杯牌的出現往往與愛情、友誼、家庭或內心感受密切相關，強調「感受」而非「行動」。', icon: 'ri-heart-line', color: '#4A90D9' },
      { suit: '寶劍組', element: '風', theme: '思維·溝通·挑戰', desc: '寶劍對應風元素，代表思維、語言、決策與衝突。寶劍組是最具兩面性的花色——正位時帶來清晰的認知與果敢；逆位時可能呈現誤解、焦慮或言語傷害。', icon: 'ri-sword-line', color: '#B79AC5' },
      { suit: '星幣組', element: '土', theme: '物質·財富·健康', desc: '星幣對應土元素，代表現實世界的物質、財富、工作與身體健康。星幣是最「腳踏實地」的花色，強調耐心積累、穩健行動與真實可見的成果。', icon: 'ri-coin-line', color: '#7BC67E' },
    ],
    numLabels: [
      { num: 'A', label: '王牌', desc: '純粹的新起點，代表該花色能量的最初萌芽與無限潛力' },
      { num: '2', label: '二號牌', desc: '選擇與平衡，兩種力量的對話與權衡' },
      { num: '3', label: '三號牌', desc: '成長與創造，力量開始顯現，有了初步成果' },
      { num: '4', label: '四號牌', desc: '穩定與休整，積蓄能量，為下一步做準備' },
      { num: '5', label: '五號牌', desc: '挑戰與變化，轉折點出現，需要應對困難' },
      { num: '6', label: '六號牌', desc: '和諧與慷慨，經歷挑戰後恢復平衡' },
      { num: '7', label: '七號牌', desc: '評估與選擇，需要深思熟慮，考驗意志' },
      { num: '8', label: '八號牌', desc: '行動與進展，努力開始顯現成效' },
      { num: '9', label: '九號牌', desc: '接近完成，堅持面對最後的考驗' },
      { num: '10', label: '十號牌', desc: '周期的終點與圓滿，一個階段的完成' },
      { num: 'P', label: '侍從', desc: '熱情初學者，充滿好奇與可能性，代表消息與新開始' },
      { num: 'Kn', label: '騎士', desc: '行動力與追求，使命感強烈，勇往直前的冒險者' },
      { num: 'Q', label: '王后', desc: '成熟智慧，滋養他人，具有內在掌控力的女性原型' },
      { num: 'K', label: '國王', desc: '權威領導，外在掌控，成熟完整的男性原型' },
    ],
    cardReadingLabel: '牌面解讀',
    uprightLabel: '✦ 正位',
    reversedLabel: '✧ 逆位',
    otherPosition: '若出現{{otherSide}}，則代表……',
    majorArcanaFull: '大阿爾卡納 No.',
  },

  trainer: {
    profileTitle: '塔羅學習檔案',
    birthdayLabel: '生日',
    profileSuffix: '塔羅學習檔案',
    consecutiveDays: '連續天',
    learnedCards: '已掌握',
    learnedUnit: '張',
    practiceCount: '練習次數',
    practiceUnit: '次',
    accuracy: '正確率',
    trainerNameTag: '識牌訓練器',
    trainerScopeNote: '當前模組專注「識牌」——認識牌面、記憶牌義、感知關鍵詞。高階的組合牌閱讀與牌陣叙事需在「占卜記錄日記」中透過真實練習逐步培養。',
    modeTitle: '訓練模式',
    comboModeTitle: '組合牌閱讀（進階）',
    comboModeDesc: '同時給出兩張牌，訓練識別兩牌的能量組合方向，是進階讀牌的基礎能力',
    comboModeTag: '新增',
    challengeTitle: '今日挑戰 · 牌面識別',
    questionPrefix: '第 {{n}} 題',
    questionDesc: '憑直覺識別以下塔羅牌，無需查閱牌義：',
    answerLabel: '答案',
    nextQuestion: '下一題 →',
    correctCount: '正確 {{count}}/{{total}}',
    startPractice: '開始練習',
    howToPractice: '如何練習',
    modes: [
      { id: 'visual', icon: 'ri-eye-line', title: '牌面識別', desc: '快速識別塔羅牌，培養視覺記憶與直覺感知', color: '#7B5EA7', steps: ['每次隨機展示一張牌面圖片', '不看文字，憑記憶說出牌名', '進階：說出3個關鍵詞', '目標：78張塔羅牌全部熟練識別'] },
      { id: 'meaning', icon: 'ri-book-open-line', title: '牌義記憶', desc: '系統掌握正逆位含義，建立完整的塔羅認知體系', color: '#D4AF37', steps: ['選擇一張牌，遮住文字', '先憑感覺寫下正位和逆位關鍵詞', '對照標準牌義，檢驗差距', '每天練習5-10張，循環複習'] },
      { id: 'intuition', icon: 'ri-lightbulb-line', title: '直覺訓練', desc: '不看牌義，憑感覺解讀牌面，培養塔羅直覺力', color: '#4A90D9', steps: ['隨機抽一張牌，不查牌義', '寫下你的第一感受（3-5個詞）', '用一段話解釋這張牌對你的意義', '長期積累，建立自己的牌義系統'] },
      { id: 'spread', icon: 'ri-layout-grid-line', title: '牌陣練習', desc: '熟練運用各種牌陣，提升綜合解讀與敘事能力', color: '#7BC67E', steps: ['先從三張牌（過去現在未來）開始', '每次抽完先自己解讀，再查書', '記錄在日記中，定期回顧', '熟練後嘗試五張牌、凱爾特十字'] },
      { id: 'combo', icon: 'ri-shuffle-line', title: '組合牌閱讀', desc: '同時認識兩張牌的能量組合，訓練進階綜合解讀能力', color: '#D14B45', steps: ['展示兩張牌及其正逆位資訊', '從四個選項中選出兩張牌能量組合的關鍵詞對', '強調正逆位對組合意義的影響', '目標：找出兩張牌之間的共鳴關係'] },
    ],
    quizOptions: ['星星', '月亮', '太陽', '審判', '愚者', '魔術師', '女祭司', '皇帝', '命運之輪', '教皇', '戰車', '力量', '節制', '吊人', '死神', '審判', '世界'],
    mode_visual: '牌面識別',
    mode_meaning: '牌義記憶',
    mode_intuition: '直覺訓練',
    mode_spread: '牌陣練習',
    mode_combo: '組合牌閱讀',
    mode_relation: '兩張牌關係判斷',
    mode_position: '牌位匹配練習',
    mode_qa: '問題—答案匹配',
    comboPromptHint: '判斷這兩張牌的能量組合方向',
    practiceComplete: '練習完成',
    practiceResult: '本次練習答對 {{correct}} / {{total}} 題',
    correctRate: '正確率',
    learnedThisRound: '本輪掌握',
    questionsCount: '題目數',
    backToTrainer: '返回訓練器',
    questionProgress: '第 {{current}} / {{total}} 題',
    correctFeedback: '答對了！繼續保持',
    wrongFeedback: '答錯了，記住這張牌的信息',
    selectAnswerHint: '請選擇答案',
    seeResult: '查看結果',
    dailyChallenge: '今日挑戰',
    dailyChallengeDesc: '完成今日5題牌面識別挑戰，鞏固你的視覺記憶',
    startChallenge: '開始挑戰',
  },

  diary: {
    recordCount: '共 {{n}} 條記錄',
    newBtn: '新建',
    moodLabel: '心情',
    records: [
      { date: '2026-03-21', time: '14:30', question: '這段時期工作上的努力會有回報嗎？', card: '太陽', en: 'The Sun', position: '正位', mood: '期待', color: '#E8A020', summary: '太陽正位帶來光明與成就感，努力正在積累，好結果正在路上。' },
      { date: '2026-03-20', time: '09:15', question: '我和ta之間的感情能走向未來嗎？', card: '戀人', en: 'The Lovers', position: '正位', mood: '心動', color: '#D14B45', summary: '戀人正位象徵真實的連結與價值觀的契合，感情基礎穩固。' },
      { date: '2026-03-18', time: '21:45', question: '現在適合開展新的副業項目嗎？', card: '命運之輪', en: 'Wheel of Fortune', position: '正位', mood: '興奮', color: '#7BC67E', summary: '命運之輪轉動，時機正在靠近，順勢而為，把握這波能量。' },
      { date: '2026-03-15', time: '16:20', question: '如何才能提升自己的表達能力？', card: '魔術師', en: 'The Magician', position: '逆位', mood: '思考', color: '#7B5EA7', summary: '魔術師逆位提醒檢視散漫狀態，重新聚焦，踏實練習才是關鍵。' },
      { date: '2026-03-12', time: '11:00', question: '最近總是感到疲憊是什麼原因？', card: '吊人', en: 'The Hanged Man', position: '正位', mood: '困惑', color: '#4A90D9', summary: '吊人提示需要主動暫停，換個視角，休息本身也是一種智慧。' },
    ],
  },

  cases: {
    intro: '塔羅牌不預測命運，而是揭示能量模式。以下案例通過著名人物的生命軌跡，幫助你更直觀地理解塔羅原型的核心含義。點擊展開可查看深度解析與人生啟示。',
    deepAnalysis: '深度解析 · {{card}}（{{en}}）',
    yourLesson: '對你的啟示',
    aboutCard: '關於「{{card}}」',
    aboutCardDesc: '「{{card}}」是塔羅 78 張中大阿卡那的原型牌之一，象徵一種普遍的人類原型能量——它的出現，意味著這種原型能量正在當事人生命中活躍。歷史名人的生命軌跡與塔羅能量的高度吸引，正是理解這張牌原型內涵的最直觀方式。',
    collapseLabel: '收起',
    footer: '以上案例僅為學習參考，基於公開資料與塔羅能量模式推演，不代表對當事人的任何定性評判。',
    persons: [
      { name: '史蒂夫·賈伯斯', title: 'Apple 創辦人', card: '魔術師', cardNum: '1', en: 'The Magician', color: '#7B5EA7', summary: '魔術師代表將想法變為現實的能力——賈伯斯以超凡的創造力與意志力，將想象中的產品化為改變世界的現實，展現了典型的魔術師能量。', deep: '魔術師牌在卡巴拉生命之樹中對應「貝斯（Beth）」路徑，象徵意志力與工具的掌控。賈伯斯從最初的蘋果車庫創業到發布iPhone，始終展現出魔術師最核心的特質。他的「現實扭曲力場」正是魔術師能量最具現代感的詮釋。', lesson: '魔術師提醒我們：你手中已有創造奇跡所需的一切工具，關鍵在於是否有勇氣施展它們。', keywords: ['意志力', '創造', '工具掌控', '顯化'] },
      { name: '奧黛麗·赫本', title: '傳奇影星 · 慈善家', card: '星星', cardNum: '17', en: 'The Star', color: '#4A90D9', summary: '星星代表希望、靈感與無私的給予。赫本以典雅的氣質和無盡的善意照亮周圍每一個人，是星星能量最美的詮釋。', deep: '星星（The Star）是塔羅中承接「塔」（混亂與毀滅）之後出現的牌，代表風暴後的希望之光。赫本年幼時經歷二戰的飢餓與苦難，卻將這段經歷轉化為對聯合國兒童基金會的終身奉獻。', lesson: '星星告訴我們：你不需要先變得完美才能給予。傷痛本身可以成為理解他人的橋梁，而無私的給予最終會讓自己也成為那道光。', keywords: ['希望', '療愈', '無私', '靈感', '淨化'] },
      { name: '伊隆·馬斯克', title: '科技企業家', card: '戰車', cardNum: '7', en: 'The Chariot', color: '#E8A020', summary: '戰車象徵以堅定意志克服一切障礙的力量。馬斯克以前所未有的決心同時推動多個顛覆性項目，展現了戰車正位的極致能量。', deep: '戰車牌的深層象徵是「雙重力量的掌控」——牌面上的兩匹馬（常為黑白色）代表正負兩種衝動力量，只有以意志駕馭兩者，才能前行。', lesson: '戰車的力量來自於駕馭，而非蠻力。確認方向之後，把所有能量凝聚在目標上——一步一步，戰車才能真正抵達終點。', keywords: ['意志', '駕馭', '前進', '勝利', '自律'] },
      { name: '瑪麗·居里', title: '兩度諾貝爾獎得主', card: '女祭司', cardNum: '2', en: 'The High Priestess', color: '#B79AC5', summary: '女祭司象徵深邃的內在智慧與對神秘的探索。居里夫人以超凡的直覺與耐心揭開放射性的秘密，是女祭司能量的歷史典範。', deep: '女祭司坐守兩根柱子之間——代表著已知與未知世界的門檻守護者。居里夫人作為19世紀的女性，面對的是學術界雙重的偏見，卻以驚人的直覺感知到放射性現象中隱藏的宇宙真理。', lesson: '女祭司提醒我們：智慧不來自喧囂，而來自靜默中的深度傾聽。', keywords: ['直覺', '智慧', '神秘', '內在知識', '耐心'] },
      { name: '曼德拉', title: '南非總統 · 諾貝爾和平獎', card: '力量', cardNum: '8', en: 'Strength', color: '#D14B45', summary: '力量牌象徵以溫柔征服猛獸——這不是蠻力的征服，而是通過愛與耐心馴服內心最狂野的恐懼。曼德拉在牢中度過27年，出獄後選擇寬恕而非復仇，正是力量牌最震撼人心的詮釋。', deep: '力量牌（Strength）在不同牌組的傳統中被賦予數字8，代表無限循環（∞）般的內在耐力。曼德拉27年的監禁可以視作這個「馴服猛獸」的過程：他馴服了內心的仇恨與絕望，最終以更純粹的愛走出來，創造了和解的奇蹟。', lesson: '力量告訴我們：真正的勇氣不是沒有恐懼，而是在恐懼面前仍然選擇愛。每次你克制憤怒、選擇理解，都是在踐行力量牌的智慧。', keywords: ['內在力量', '溫柔', '耐心', '勇氣', '慈悲'] },
    ],
  },

  love: {
    bannerTitle: '愛情運勢 · {{period}}',
    dimTitle: '四維能量評分',
    expandHint: '點擊展開詳析',
    mainCardTitle: '月度主牌',
    singleTitle: '單身者',
    coupleTitle: '戀愛中',
    practicalAdvice: '實用建議',
    beginnerTitle: '塔羅愛情解讀入門',
    beginnerTag: '小白必讀',
    resolutionFrom: '—— 來自「{{card}}」的智慧',
    personalNote: '以上為 {{name}} 的 {{period}} 愛情專屬推算',
    scoreTipHigh: '旺盛',
    scoreTipMid: '平穩',
    scoreTipLow: '蓄力期',
    peachHigh: '本月你的個人魅力正在蓬勃散發，社交場合中的存在感更強，周圍人對你的關注自然增加。',
    peachLow: '暫時不必刻意追求關注，專注內在充實，氣場會在合適的時候自然流露。',
    destinyHigh: '正緣時機本月處於高能量期，重要緣分或許正悄然靠近，保持開放心態，不要因焦慮錯過身邊的可能。',
    destinyLow: '正緣時機本月處於蓄力期，不必刻意催促命運。真正的正緣不會因你晚一步到達而錯過，在等待中認識更好的自己才是重點。',
    singleTips: ['放鬆心態，真實的自己比精心包裝的形象更有吸引力', '擴大社交圈，但不強求，遇見有趣的人本身就是收穫', '與其等待完美的人，不如成為更豐盛的自己'],
    coupleTips: ['日常中的小細節勝過偶爾的盛大浪漫', '遇到分歧時先「理解」再「表達」，順序很重要', '給對方空間也是愛，親密與獨立並不矛盾'],
    beginnerItems: [
      { title: '塔羅不預測命運，只反映能量', color: '#D14B45', content: '塔羅牌是一個象徵與直覺的工具系統，它映射的是你當前的能量狀態與潛意識傾向，而非刻在石頭上的命運。同一張牌在不同人手中、不同問題下，解讀可以完全不同。' },
      { title: '愛情中的「聖杯」是主角', color: '#4A90D9', content: '塔羅78張牌分為大小阿爾卡納。在愛情運勢中，大阿爾卡納的「戀人」「聖杯王后」「月亮」等牌權重最高；小阿爾卡納中，聖杯組（對應水元素/情感）是愛情的主要信號牌。' },
      { title: '正位與逆位的真實含義', color: '#7BC67E', content: '正位≠好，逆位≠壞。正位代表牌面能量流暢外顯，逆位代表能量受阻或內斂。逆位更像是一個提醒：「這裡需要你多一點關注與調整」，是成長的邀請，不是懲罰。' },
      { title: '運勢分數只是參考', color: '#B79AC5', content: '本頁面的分數是通過命主生日信息與當月能量綜合運算的數值化結果，旨在幫助你直觀感知能量趨勢。請把它當作參考方向，而不是硬性判斷。' },
    ],
    dims: [
      { key: 'single', label: '單身運勢', icon: 'ri-user-heart-line', color: '#D14B45', intro: '【單身運勢】衡量本月遇見新緣分的能量強弱。數值越高，越適合主動出擊；數值偏低時，重點放在自我提升，緣分會在對的時機自然顯現。' },
      { key: 'relation', label: '戀愛指數', icon: 'ri-heart-line', color: '#E8A020', intro: '【戀愛指數】代表已有伴侶的關係甜蜜度與穩定性。高分時感情順暢、雙方默契，是深化感情的好時機；低分不代表感情出問題，而是提醒雙方需要更多耐心與理解。' },
      { key: 'peach', label: '桃花運', icon: 'ri-flower-line', color: '#B79AC5', intro: '【桃花運】代表你當前對他人的吸引力，以及社交場合的魅力指數，與外貌無關，與內在能量狀態直接相關。' },
      { key: 'destiny', label: '正緣時機', icon: 'ri-time-line', color: '#7BC67E', intro: '【正緣時機】代表重要緣分是否正在靠近。高分時要保持開放；低分時無需焦慮，每人正緣的時間節點不同，順應自然是最好的策略。' },
    ],
  },

  career: {
    bannerTitle: '事業運勢 · 本週指引',
    dimTitle: '四維職場評分',
    expandHint: '點擊展開詳析',
    mainCardTitle: '本週主牌',
    threeGuideTitle: '本週三日指引',
    beginnerTitle: '塔羅事業解讀入門',
    beginnerTag: '小白必讀',
    resolutionFrom: '—— 來自「{{card}}」的智慧',
    personalNote: '以上為 {{name}} 的本週事業專屬推算',
    scoreTipHigh: '旺盛',
    scoreTipMid: '平穩',
    scoreTipLow: '蓄力中',
    guideNote: '每日指引牌是從本週主牌能量延伸生成的子牌，幫助你在具體行動日把握最佳時機與方向。',
    beginnerGuideText: '本週主牌根據你的出生資訊與本週能量共同推算而來。塔羅事業解讀不是預言你會升職或失業，而是揭示本週最適合你的行動策略——是主動出擊還是按兵不動，是創新突破還是穩守陣地。順應能量，事半功倍。',
    dims: [
      { key: 'workplace', label: '職場運勢', icon: 'ri-briefcase-line', color: '#E8A020', intro: '【職場運勢】是本週你在工作環境中整體能量的綜合體現。塔羅中「權杖」組代表行動力與創造，高分時項目推進如魚得水，低分時建議減少衝突，以穩為主。' },
      { key: 'promotion', label: '晉升機會', icon: 'ri-arrow-up-line', color: '#7BC67E', intro: '【晉升機會】反映本週出現職業躍升機遇的可能性。分數偏低時無需氣餒，厚積薄發，每次蓄力都是下次躍升的鋪墊。' },
      { key: 'benefactor', label: '貴人運', icon: 'ri-user-star-line', color: '#D4AF37', intro: '【貴人運】代表本週你身邊是否有能為你提供指引、支持或資源的人。高貴人運時，多主動求教、建立連結；低時更依靠自身積累，等待時機。' },
      { key: 'entrepreneur', label: '創業指數', icon: 'ri-rocket-line', color: '#7B5EA7', intro: '【創業指數】代表本週在副業、獨立項目或創業方面的時機能量。注意：創業指數高代表能量支持，但實際行動仍需結合充分的調研與規劃。' },
    ],
    beginnerItems: [
      { title: '權杖是事業的主戰場', color: '#E8A020', content: '塔羅78張牌中，小阿爾卡納「權杖組」（對應火元素）直接對應行動力、創造力與職業發展。大阿爾卡納中，「戰車」「皇帝」「魔術師」是事業強牌。' },
      { title: '事業牌是時機而非命運', color: '#7BC67E', content: '事業塔羅解讀的核心價值在於「時機判斷」：何時適合主動推進、何時需要蓄勢待發。它不決定你的職業高度，只幫助你更智慧地選擇行動節點。' },
      { title: '逆位事業牌不是厄兆', color: '#D14B45', content: '逆位出現在事業中，代表能量受阻或需要內化調整。每張逆位牌都是調整策略的智慧提示，而非警告。' },
      { title: '綜合理性分析才有意義', color: '#B79AC5', content: '塔羅是輔助決策的工具，不是替代理性分析的算命機器。在重要職業決策前，請綜合自身能力評估、市場情況和塔羅提供的能量方向。' },
    ],
  },

  social: {
    bannerTitle: '人際關係 · 本週指引',
    dimTitle: '四維人際評分',
    expandHint: '點擊展開詳析',
    mainCardTitle: '本週主牌',
    relAnalysisTitle: '關係分析',
    beginnerTitle: '塔羅人際解讀入門',
    beginnerTag: '小白必讀',
    personalNote: '以上為 {{name}} 的本週人際專屬推算',
    scoreTipHigh: '旺盛',
    scoreTipMid: '平穩',
    scoreTipLow: '蓄力中',
    statusLabel: '狀態說明',
    weeklyAdvice: '本週行動建議',
    relTypes: { colleague: '同事關係', friend: '朋友關係', family: '家庭關係' },
    statusLabels: {
      harmonious: '和諧', stable: '穩定', active: '活躍',
      warming: '升溫', peaceful: '平和', tense: '稍緊',
    },
    statusIntro: {
      harmonious: '雙方能量流動順暢，是深化關係的好時機，主動分享與表達可以讓聯結更堅固。',
      stable: '關係處於穩定平衡期，現有基礎良好，保持日常用心即可，無需刻意改變。',
      active: '互動頻率與話題都處於高峰期，社交活力十足，適合進行重要的坦誠溝通。',
      warming: '關係正在升溫階段，細水長流，把握每一次真誠互動都是加分項。',
      peaceful: '關係平淡但穩健，無特別波動，是休整與思考的平靜期，維持就好。',
      tense: '關係略有張力，可能存在未解決的小摩擦，主動尋求坦誠溝通有助於化解。',
    },
    dims: [
      { key: 'social', label: '社交運勢', icon: 'ri-team-line', color: '#7BC67E', intro: '【社交運勢】是本週你整體人際互動能量的綜合體現。高分時，你的表達更流暢、印象更正面，適合主動建立新連結或深化現有關係；低分時，建議放緩社交節奏。' },
      { key: 'benefactor', label: '貴人運', icon: 'ri-user-star-line', color: '#D4AF37', intro: '【貴人運】代表你身邊出現對你有實質幫助的人的概率。保持開放與感恩的心態，是召喚貴人最有效的方式。' },
      { key: 'shield', label: '人際防護', icon: 'ri-shield-line', color: '#8A7B91', intro: '【人際防護】衡量本週你抵禦負面人際干擾的能力。低分時建議保持低調，減少不必要的信息暴露。' },
      { key: 'charm', label: '人緣指數', icon: 'ri-heart-3-line', color: '#D14B45', intro: '【人緣指數】反映你本週在他人眼中的整體印象分。與外貌無關，主要來自你的能量狀態、傾聽能力和表達方式。' },
    ],
    beginnerItems: [
      { title: '聖杯組是人際的主戰場', color: '#4A90D9', content: '塔羅小阿爾卡納「聖杯組」（水元素，對應情感與關係）是解讀人際關係最重要的信號來源。大阿爾卡納中「聖杯王后」「教皇」「星星」等牌在人際位置出現時，往往預示關係能量溫暖與流動。' },
      { title: '關係狀態是描述而非判決', color: '#7BC67E', content: '「稍緊」「偏弱」等低狀態標籤，是提醒你「這段關係此時需要更多關注與耐心」，而不是斷定「這段關係有問題」。' },
      { title: '貴人未必顯眼', color: '#D4AF37', content: '塔羅中的貴人能量不只來自權勢人物，一個在你低落時給出真誠建議的朋友、一個偶然轉發了你作品的陌生人，都可能是當下的貴人。' },
    ],
  },

  health: {
    bannerTitle: '健康運勢 · 本週概覽',
    dimTitle: '四維健康狀態',
    expandHint: '點擊展開詳析',
    mainCardTitle: '本週主牌',
    tipsTitle: '本週健康建議',
    beginnerTitle: '塔羅健康解讀入門',
    beginnerTag: '小白必讀',
    personalNote: '以上為 {{name}} 的本週健康專屬推算',
    scoreTipHigh: '良好',
    scoreTipMid: '一般',
    scoreTipLow: '需關注',
    dimLabel: '維度說明',
    currentStatus: '當前狀態解讀',
    statusLabels: {
      good: '良好', stable: '平穩', attention: '需關注', weak: '偏弱',
      better: '較好', clear: '清明', tired: '略有疲憊',
      relax: '需放鬆', active: '活躍', excellent: '優質', improve: '需改善',
      poor: '較差', fair: '尚可', light: '輕鬆', moderate: '中等',
      high: '偏高', adjust: '需調節', low: '較低',
    },
    statusIntro: {
      good: '當前狀態良好，繼續保持規律作息與健康習慣，是進一步提升的最好時機。',
      stable: '狀態平穩正常，無明顯波動，維持現有的健康習慣即可，不必過度關注。',
      attention: '這個維度出現了一些需要關注的信號，建議在日常中多留意身體反饋，適當調整作息與飲食。',
      weak: '此維度能量偏弱，提醒你給予更多的關注與照顧，休息和補充是當下的優先事項。',
      better: '狀態較好，有餘裕做進一步優化，適合在此基礎上建立新的健康習慣。',
      clear: '思維清晰，專注力強，抓住此時處理重要任務，效率會更高。',
      tired: '有輕度疲憊感，適當減少腦力輸出，睡眠補充是最有效的恢復方式。',
      relax: '精神偏緊繃，建議主動安排放鬆時間，正念、散步或與親友交談都能有效舒緩。',
      active: '精力充沛，思維活躍，是高效工作與創造的好狀態，好好利用。',
      excellent: '睡眠質量優秀，身體恢復充分，繼續保持規律的入睡時間。',
      improve: '睡眠質量有待提升，嘗試減少睡前螢幕使用時間，保持固定的入睡時間，避免睡前大量飲食。',
      poor: '睡眠較差會影響全天狀態，建議重視睡前儀式感，創造黑暗安靜的睡眠環境，必要時尋求專業建議。',
      fair: '睡眠基本夠用但有提升空間，細化睡前習慣能帶來明顯改善。',
      light: '壓力處於低水平，身心輕盈，是充電與學習新事物的好時機。',
      moderate: '壓力處於正常範圍，是多數人的日常狀態，注意不要讓小壓力積累成大負擔。',
      high: '壓力水平偏高，建議有意識地安排減壓活動，優先處理最重要的事，減少自我要求的完美主義。',
      adjust: '壓力需要主動調節，不要一味硬撐。找到你最有效的減壓方式並付諸行動。',
      low: '壓力很低，狀態輕鬆，但也要保持適度的目標感與動力，避免過度鬆散。',
    },
    dims: [
      { key: 'body', label: '身體狀況', icon: 'ri-heart-pulse-line', color: '#7BC67E', intro: '【身體狀況】綜合評估本週你的體力、活力與整體生理狀態。狀態良好時適合增加運動強度；需關注時則要注意休息充足，避免過度消耗。' },
      { key: 'mind', label: '精神狀態', icon: 'ri-brain-line', color: '#B79AC5', intro: '【精神狀態】反映本週你的注意力、思維清晰度與情緒穩定性。清明活躍時適合處理複雜任務和創意工作；略有疲憊時建議減少腦力消耗。' },
      { key: 'sleep', label: '睡眠質量', icon: 'ri-moon-line', color: '#4A90D9', intro: '【睡眠質量】是健康的核心指標之一。睡眠差往往不是單一問題，常與壓力、電子產品使用和作息不規律相關，找到根因比硬撐更重要。' },
      { key: 'stress', label: '壓力指數', icon: 'ri-emotion-line', color: '#E8A020', intro: '【壓力指數】衡量本週你承受的精神壓力大小。壓力偏高時需要主動釋放——不是逃避，而是找到適合自己的疏導方式（運動、傾訴、冥想等）。' },
    ],
    disclaimerTitle: '非醫療診斷 · 僅供參考',
    disclaimerText: '本模塊為身心狀態與生活節律的塔羅能量參考，不構成醫療建議，不替代專業診斷，不判斷病因，不作病情結論。如有身體不適，請及時就醫。',
    disclaimerSubNote: '塔羅 ≠ 醫學診斷 · 結果 ≠ 健康判斷 · 如有不適請就醫',
    seekHelpTitle: '以下情況請立即尋求專業幫助',
    seekHelpText: '持續兩週以上的情緒低落或絕望感 · 嚴重失眠或睡眠障礙 · 持續的身體疼痛或不明症狀 · 任何情緒危機或自傷念頭。塔羅能量參考永遠無法處理以上情況。將自己的健康交給專業醫療不是軟弱，而是對自己最真誠的負責。',
    healthClosingNote: '⚠️ 免責聲明：本頁全部內容僅供身心狀態參考，不構成任何醫療、心理診斷建議。如有持續身體不適、情緒問題或健康疑慮，請盡快尋求專業醫療或心理諮詢幫助。',
    miniDisclaimer: '僅供參考，非醫療建議',
    beginnerItems: [
      { title: '塔羅健康解讀 ≠ 醫學診斷', color: '#7BC67E', content: '重要聲明：塔羅牌提供的健康方向是一種能量趨勢參考，絕對無法替代專業醫療診斷與建議。如你有具體健康問題或身體不適，請及時尋求專業醫療建議。' },
      { title: '星星與力量是健康的守護牌', color: '#4A90D9', content: '塔羅大阿爾卡納中，「力量」象徵內在活力與恢復能力，「星星」代表療愈與淨化，「審判」有時預示健康轉機。' },
      { title: '逆位健康牌是溫和的提醒', color: '#E8A020', content: '當健康相關牌出現逆位，不要恐慌——它是在提醒你「此時你的身體/精神需要更多關注」，如同汽車儀表板上亮起的黃色燈，這是讓你檢查和維護的信號，而不是報警。' },
      { title: '最好的健康法是規律與自知', color: '#B79AC5', content: '所有塔羅健康建議的底層邏輯都是：規律作息、均衡飲食、適度運動、情緒調節。塔羅的價值在於幫你更有動力去執行這些你已經知道的事。' },
    ],
  },

  wealth: {
    bannerTitle: '財富運勢 · {{period}}',
    dimTitle: '四維財運評分',
    expandHint: '點擊展開詳析',
    mainCardTitle: '月度主牌',
    salaryDetailTitle: '正財運勢詳析',
    windDetailTitle: '偏財運勢詳析',
    planDetailTitle: '理財策略建議',
    beginnerTitle: '塔羅財運解讀入門',
    beginnerTag: '小白必讀',
    personalNote: '以上為 {{name}} 的 {{period}} 財運專屬推算',
    scoreTipHigh: '旺盛',
    scoreTipMid: '平穩',
    scoreTipLow: '蓄力中',
    investHigh: '時機相對有利，可考慮分散佈局穩健型資產，但仍需結合個人風險承受能力做決策。',
    investLow: '本月投資能量偏弱，建議減少新倉位開設，以觀望和學習為主，守住現有資產比追求收益更重要。',
    saveHigh: '執行節流計劃、設立儲蓄目標的好時機，本月你對財務的掌控力較強，制定預算並執行會事半功倍。',
    saveLow: '本月消費衝動偏強，建議在購物前給自己設24小時冷靜期，區分「想要」與「需要」，避免衝動消費積累。',
    profileNote: '專屬推算',
    dims: [
      { key: 'salary', label: '正財運', icon: 'ri-money-cny-circle-line', color: '#7BC67E', intro: '【正財運】代表通過正當勞動獲得收入的運勢，包括薪資漲幅、項目獎金、工作回報等。正財運穩定是財富積累的根基。' },
      { key: 'wind', label: '偏財運', icon: 'ri-coin-line', color: '#E8A020', intro: '【偏財運】代表通過非主業途徑獲得收入的可能性，如副業、意外之財、投資收益、禮物贈予等。注意：偏財運高時代表有「機遇窗口」，但需理性判斷。' },
      { key: 'invest', label: '投資運', icon: 'ri-stock-line', color: '#4A90D9', intro: '【投資運】評估本月在股票、基金、房產、創業投入等方面的時機能量。投資運低時，建議以觀望為主；投資運高時也僅代表時機相對有利，並非保證盈利。' },
      { key: 'save', label: '儲蓄力', icon: 'ri-safe-line', color: '#D4AF37', intro: '【儲蓄力】衡量本月自律控制支出、積累財富的內在驅動力。無論投資運高低，保持穩定的儲蓄習慣始終是最可靠的財富增長方式。' },
    ],
    beginnerItems: [
      { title: '星幣組是財富的直接信號', color: '#D4AF37', content: '塔羅小阿爾卡納「星幣組」（對應土元素）是財富、物質與現實資源的代言人。大阿爾卡納中「太陽」「命運之輪」「世界」也常與財運正向關聯。' },
      { title: '塔羅財運≠精準預測金額', color: '#7BC67E', content: '塔羅給出的是「能量趨勢」而非精確數字預測。它告訴你本月財務能量的整體方向（增長/守成/謹慎），幫助你做出更有智慧的財務決策。' },
      { title: '高財運≠躺贏，低財運≠躺平', color: '#4A90D9', content: '財運再高也需要你的行動配合；財運偏低時更需要聰明地守護現有資產。塔羅是你的戰略顧問，但執行者永遠是你自己。' },
    ],
  },
  'boundaryReminder.title': '邊界提醒',
  'boundaryReminder.content': '塔羅牌以圖像喚醒潛意識，牌面是內心的鏡子而非命運的預言。它幫你看見自己，但路仍要你自己走。當前內容資訊僅供娛樂使用，不等於專業測評，不代表價值評判，無任何現實指導意義，僅供娛樂參考。',
  'safeHarbor.title': '避風港提醒',
  'safeHarbor.content': '塔羅牌占卜為傳統民俗文化，當前內容資訊僅供娛樂使用，不等於專業測評，不代表價值評判，無任何現實指導意義，僅供娛樂參考。',
};

export default tarotDetail;
